<template>
  <span
    v-if="svgContent"
    v-html="svgContent"
    class="base-icon overflow-visible"
    :style="iconStyle"
  />
</template>

<script>
export default {
  name: 'BaseIcon',
  props: {
    name: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      default: null,
    },
    size: {
      type: [Number, String],
      default: 16,
    },
  },
  data() {
    return {
      svgContent: '',
    };
  },
  computed: {
    iconStyle() {
      return {
        color: this.color,
        width: `${this.size}px`,
        height: `${this.size}px`,
      };
    },
  },
  watch: {
    name() {
      this.loadIcon();
    },
  },
  mounted() {
    this.loadIcon();
  },
  methods: {
    async loadIcon() {
      try {
        const module = await import(`@/assets/svg/${this.name}.svg`);
        const url = module.default;
        if (url.startsWith('data:image/svg+xml;base64,')) {
          this.svgContent = atob(url.replace('data:image/svg+xml;base64,', ''));
        } else {
          const response = await fetch(url);
          this.svgContent = await response.text();
        }
      } catch (error) {
        console.error(`Error loading icon "${this.name}":`, error);
      }
    },
  },
};
</script>

<style scoped>
.base-icon {
  display: inline-flex;
  align-items: center;
}
.base-icon ::v-deep svg {
  width: 100%;
  height: 100%;
}
</style>
